import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// FAQ data pour la gestion de la prospection
const faqItems = [
  {
    id: 1,
    title: "Prospects Élèves",
    content: "Centralisez et suivez tous vos prospects élèves depuis une interface unique. Automatisez vos relances et personnalisez vos communications pour maximiser vos conversions.",
    details: [
      "Scoring automatique des prospects",
      "Relances personnalisées et automatisées",
      "Suivi des interactions en temps réel"
    ]
  },
  {
    id: 2,
    title: "Entreprises Partenaires",
    content: "Développez votre réseau d'entreprises partenaires et gérez efficacement vos relations commerciales pour placer vos apprenants.",
    details: [
      "Base de données entreprises enrichie",
      "Historique des échanges centralisé", 
      "Suivi des opportunités de partenariat"
    ]
  },
  {
    id: 3,
    title: "Offres d'Emploi",
    content: "Collectez, organisez et diffusez les offres d'emploi de vos partenaires. Facilitez le matching entre vos apprenants et les opportunités du marché."
  },
];

const SolutionEmargement = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Texte et FAQ */}
          <div className={styles.leftContent}>
            <h2 className={cn("h2", styles.title)}>
              Optimisez votre prospection et développez votre réseau
            </h2>
            <div className={styles.info}>
              Boostez vos conversions de grâce à notre CRM intégré. Automatisez vos tâches répétitives et concentrez-vous sur les prospects les plus qualifiés.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>

          {/* Côté droit - Galerie d'images */}
          <div className={styles.rightContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/prospection-illustration.svg"
                      alt="Interface de gestion de la prospection"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInRight" 
                offset={400}
                style={{
                  position: 'absolute',
                  top: '15%',
                  right: '2%',
                  zIndex: 3
                }}
              >
                <img
                  src="/images/content/prospection-leads.svg"
                  alt="Gestion des prospects"
                  className={styles.floatingMedium}
                />
              </ScrollParallax>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInUp" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-15%',
                  left: '8%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/prospection-entreprises.svg"
                  alt="Réseau d'entreprises"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionEmargement;
